const getElementById = (id) => document.getElementById(id);
const fmtMoney0 = (n) => (n < 0 ? "-$" : "$") + Math.abs(Math.round(n)).toLocaleString();

function calculate(){
    // Inputs
    const E = Math.max(1, +getElementById("employees_tr").value || 0);
    const R = Math.max(0, +getElementById("billRate").value || 0);
    const D = Math.max(1, +getElementById("projectDays").value || 0);
    const W = Math.max(0, +getElementById("walkTime").value || 0);
    const timeSavedRaw = Math.max(0, +getElementById("timeSaved").value || 0);
    const timeSaved = Math.min(timeSavedRaw, W);
    if (timeSaved !== timeSavedRaw) getElementById("timeSaved").value = timeSaved;
    const N = Math.max(1, +getElementById("busCount").value || 1);

    // Baseline walking dollars
    const walkDay  = E * (R / 60) * W;
    const walkProj = walkDay * D;

    // Calculate actual bus time = walking time - time saved
    const actualBusTime = W - timeSaved;
    
    // Transportation cost has two components:
    // 1. Time cost: employees still spend time on the bus (less than walking)
    const busTimeCostDay = E * (R / 60) * actualBusTime;
    const busTimeCostProj = busTimeCostDay * D;
    
    // 2. Operational cost: fixed costs to run buses (drivers, fuel, maintenance)
    // At defaults: total was $1,488,040, time cost was $1,300,000, so operational = $188,040
    const baseOperationalProj = 188040;
    const baseBusesCount = 10;
    const operationalPerBus = baseOperationalProj / baseBusesCount;
    
    // Scale operational costs with number of buses and minor adjustments
    const baseEmployees = 500;
    const baseBillRate = 75;
    const scaleFactor = Math.sqrt((E / baseEmployees) * (R / baseBillRate));
    
    const operationalCostProj = operationalPerBus * N * scaleFactor;
    const operationalCostDay = operationalCostProj / D;
    
    // Total transportation cost
    const transProj = busTimeCostProj + operationalCostProj;
    const transDayExact = busTimeCostDay + operationalCostDay;

    // Time saved calculation
    const deltaMins   = timeSaved;
    const minsSaved   = deltaMins * E * D;
    const hoursSaved  = minsSaved / 60;
    const savingsDay  = E * (R / 60) * deltaMins;
    const savingsProj = savingsDay * D;

    // Net savings = walking cost MINUS transportation cost
    const net = walkProj - transProj;

    // ---- Outputs ----
    getElementById("totalSavings").textContent = fmtMoney0(net);

    // Current State
    getElementById("currentDaily").textContent   = fmtMoney0(walkDay);
    getElementById("currentProject").textContent = fmtMoney0(walkProj);

    // Transportation System Cost
    getElementById("transportDaily").textContent   = fmtMoney0(transDayExact);
    getElementById("transportProject").textContent = fmtMoney0(transProj);

    // Detailed Cost Breakdown
    getElementById("walkingCostDisplay").textContent   = fmtMoney0(walkProj);
    getElementById("transportCostDisplay").textContent = fmtMoney0(transProj);
    getElementById("timeSavedDisplay").textContent     = `${Math.round(deltaMins).toLocaleString()} minutes/day`;
    getElementById("totalTimeRecovered").textContent   = `${Math.round(minsSaved).toLocaleString()} minutes`;
    getElementById("netSavingsDisplay").textContent    = fmtMoney0(net);

    // ROI Summary
    const savingsPct = walkProj > 0 ? (savingsProj / walkProj) * 100 : 0;
    getElementById("savingsPercent").textContent  = `${Math.round(savingsPct).toLocaleString()}%`;
    getElementById("productiveHours").textContent = Math.round(hoursSaved).toLocaleString();
    getElementById("costPerEmployee").textContent = fmtMoney0(transProj / E);
}

["employees_tr","billRate","projectDays","walkTime","timeSaved","busCount"]
    .forEach(id => getElementById(id).addEventListener("input", calculate));

getElementById("resetBtn").addEventListener("click", ()=>{
    getElementById("employees_tr").value   = 500;
    getElementById("billRate").value    = 75;
    getElementById("projectDays").value = 260;
    getElementById("walkTime").value    = 15;
    getElementById("timeSaved").value   = 7;
    getElementById("busCount").value    = 10;
    calculate();
});

window.addEventListener("load", calculate);